import script from "./SpeechRecognizer.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeechRecognizer.vue?vue&type=script&setup=true&lang=js"

import "./SpeechRecognizer.vue?vue&type=style&index=0&id=5c3d277b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3d277b"]])

export default __exports__